import { render, staticRenderFns } from "./BonusRequestHistory.vue?vue&type=template&id=48d59f52&scoped=true"
import script from "./BonusRequestHistory.vue?vue&type=script&lang=js"
export * from "./BonusRequestHistory.vue?vue&type=script&lang=js"
import style0 from "./BonusRequestHistory.vue?vue&type=style&index=0&id=48d59f52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d59f52",
  null
  
)

export default component.exports